var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlankValuesOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.583 2H2.5C1.39543 2 0.5 2.89543 0.5 4V18C0.5 19.1046 1.39543 20 2.5 20H11.583C12.6876 20 13.583 19.1046 13.583 18V4C13.583 2.89543 12.6876 2 11.583 2Z",
    fill: "#272D55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.583 2.5H2.5C1.67157 2.5 1 3.17157 1 4V18C1 18.8284 1.67157 19.5 2.5 19.5H11.583C12.4114 19.5 13.083 18.8284 13.083 18V4C13.083 3.17157 12.4114 2.5 11.583 2.5Z",
    stroke: "#272D55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01953 3C7.84796 3 8.51953 2.32843 8.51953 1.5C8.51953 0.671573 7.84796 0 7.01953 0C6.1911 0 5.51953 0.671573 5.51953 1.5C5.51953 2.32843 6.1911 3 7.01953 3Z",
    fill: "#AECDFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01953 2.5C7.57182 2.5 8.01953 2.05228 8.01953 1.5C8.01953 0.947715 7.57182 0.5 7.01953 0.5C6.46725 0.5 6.01953 0.947715 6.01953 1.5C6.01953 2.05228 6.46725 2.5 7.01953 2.5Z",
    stroke: "#AECDFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43 8.52C4.43 8.92 4.73 9.13 5.08 9.13C6.05 9.13 5.55 7.81 6.83 7.81C7.43 7.81 7.79 8.13 7.79 8.67C7.79 9.65 6.04 9.92 6.04 11.11C6.04 11.43 6.25 11.78 6.68 11.78C7.34 11.78 7.26 11.29 7.5 10.94C7.82 10.47 9.31 9.97 9.31 8.67C9.31 7.26 8.05 6.67 6.77 6.67C5.55 6.67 4.43 7.54 4.43 8.52ZM5.9 13.25C5.9 13.7 6.27 14.07 6.72 14.07C7.17 14.07 7.54 13.7 7.54 13.25C7.54 12.8 7.17 12.43 6.72 12.43C6.27 12.43 5.9 12.8 5.9 13.25Z",
    fill: "#AECDFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankValuesOperationIcon);
export default __webpack_public_path__ + "static/media/BlankValuesOperationIcon.252022c5733a6f2f7bebbd31bf53b37e.svg";
export { ForwardRef as ReactComponent };